import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import AddControl from 'components/add_control';

import Row from './row';
import ScheduleModal from './modal';

import './styles.scss';

export function ScheduleTable({ isParentCompanyUser, royaltySchedules }) {
  const [showModal, setShowModal] = useState();

  return <React.Fragment>
    <div className="settings-header">
      <h3 className="header-title">Royalty Schedule (Sale / Lease / Other)</h3>
      {isParentCompanyUser &&
        <div className="actions">
          <AddControl name="add-schedule" onClick={() => setShowModal(true)}>Add Royalty Schedule</AddControl>
        </div>}
    </div>
    <table className="table royalty-settings-table">
      <thead>
        <tr>
          {isParentCompanyUser &&
            <React.Fragment>
              <th>Name</th>
              <th>Royalty Pattern Name</th>
            </React.Fragment>}
          <th className="text-center">Tiers</th>
          <th className="text-center"># Agents</th>
          <th className="text-center"># Agents Paid</th>
          <th className="text-right">YTD Gross Commission</th>
          <th className="text-right">Current Tier</th>
          {isParentCompanyUser &&
            <React.Fragment>
              <th className="text-center">Last Updated</th>
              <th className="actions">Actions</th>
            </React.Fragment>
          }
        </tr>
      </thead>

      <tbody>
        {royaltySchedules
          .filter(royaltySchedule => isParentCompanyUser || royaltySchedule.companyDefault)
          .map(royaltySchedule => (
            <Row
              isParentCompanyUser={isParentCompanyUser}
              key={royaltySchedule.id}
              royaltySchedule={royaltySchedule}
            />
          ))}
      </tbody>
    </table>
    <ScheduleModal show={showModal} onClose={() => setShowModal(false)} />
  </React.Fragment>;
}

ScheduleTable.propTypes = {
  isParentCompanyUser: PropTypes.bool,
  royaltySchedules: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })),
};

const mapStateToProps = ({ isParentCompanyUser, royaltySchedules }) => ({
  isParentCompanyUser,
  royaltySchedules: royaltySchedules.schedules,
});

export default connect(mapStateToProps)(ScheduleTable);
